import * as _ from "lodash";
import {AnyAction} from "redux";
import {createSelector} from "reselect";
import {getPopulatedPowerSources} from "../powerSources";
import {getEnergyMixData, getPowerSourceLocationsData, getPowerSourcesData, IEnergyMixDictionary, IPowerSource, IPowerSourceLocation} from "../../../data/data";

/**
 * get the ideal amount of env. impact
 * @returns {number}
 */
export function getTargetEnvironmentalImpact() : number
{
    const locations: IPowerSourceLocation[] = getPowerSourceLocationsData();
    const power_sources: IPowerSource[] = getPowerSourcesData();
    const ratios: IEnergyMixDictionary = getEnergyMixData();

    const impact_sum: number = _.reduce(power_sources, (sum: number, power_source: IPowerSource) =>
    {
        return sum + (ratios[power_source.id] * 0.01 * locations.length) * power_source['environmental-impact'];
    }, 0)

    return impact_sum;
}


//  define selectors

/**
 * get the total env. impact of all power sources
 */
export const getEnvironmentalImpact = createSelector(

    [getPopulatedPowerSources],

    (power_sources: IPowerSource[]) =>
    {
        if (! power_sources.length) return 0;

        return _.sumBy(power_sources, 'environmental-impact');
    }
);


/**
 * get the total env. impact of all power sources
 */
export const getEnvironmentalImpactRatio = createSelector(

    [getEnvironmentalImpact, getTargetEnvironmentalImpact],

    (actual: number, target: number) : number =>
    {
        if (! actual) return 0;

        const ratio: number = _.clamp(actual / (target * 2), 0, 1);

        // console.group('getEnvironmentalImpactRatio');
        // console.log('actual', actual);
        // console.log('target', target);
        // console.log('ratio', ratio);
        // console.groupEnd();

        return parseFloat(ratio.toFixed(2));
    }
);


//  define the initial state

const initialState: number = 0;


/**
 * reducer: set the current environmental-friendliness
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function environmentalImpact(state: number = initialState, action: AnyAction) : number
{
    switch (action.type)
    {
        default:

            return state;
    }
}


// WEBPACK FOOTER //
// ./src/ts/store/reducers/outputs/environmentalImpact.ts